export function getGlobalPlaygroundAPIBaseURL(): string {
  if (typeof window !== 'undefined' && window.__ANIMA_PLAYGROUND_API_BASE_URL__) {
    return window.__ANIMA_PLAYGROUND_API_BASE_URL__;
  }

  return __DEFAULT_ANIMA_PLAYGROUND_API_BASE_URL__;
}

export function getGlobalAccountsBaseURL(): string {
  if (typeof window !== 'undefined' && window.__ANIMA_ACCOUNTS_BASE_URL__) {
    return window.__ANIMA_ACCOUNTS_BASE_URL__;
  }

  return __DEFAULT_ANIMA_ACCOUNTS_BASE_URL__;
}
